import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin } from 'lucide-react';
export function Contact() {
  return <main className="pt-24 pb-20 bg-surface min-h-screen" data-id="element-426">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl" data-id="element-427">
        <div className="text-center mb-16" data-id="element-428">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-5xl font-heading font-extrabold text-navy mb-4" data-id="element-429">
            Get in Touch
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-xl text-muted max-w-2xl mx-auto" data-id="element-430">
            Ready to dominate local search? Contact us today for a free audit.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-431">
          {[{
          icon: Phone,
          title: 'Call Us',
          detail: '+1 (555) 123-4567'
        }, {
          icon: Mail,
          title: 'Email Us',
          detail: 'hello@globalremote.agency'
        }, {
          icon: MapPin,
          title: 'Location',
          detail: 'Fully Remote (Global)'
        }].map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2 + index * 0.1
        }} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 text-center flex flex-col items-center" data-id="element-432">
              <div className="w-12 h-12 bg-blue-soft rounded-full flex items-center justify-center mb-4 text-blue" data-id="element-433">
                <item.icon size={24} data-id="element-434" />
              </div>
              <h3 className="font-bold text-navy text-lg mb-2" data-id="element-435">{item.title}</h3>
              <p className="text-muted" data-id="element-436">{item.detail}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden max-w-3xl mx-auto" data-id="element-437">
          <div className="p-8 md:p-12" data-id="element-438">
            <h2 className="text-2xl font-heading font-bold text-navy mb-6 text-center" data-id="element-439">
              Send us a message
            </h2>
            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-440">
              <div className="grid md:grid-cols-2 gap-6" data-id="element-441">
                <div data-id="element-442">
                  <label className="block text-sm font-medium text-navy mb-2" data-id="element-443">
                    First Name
                  </label>
                  <input type="text" className="w-full px-4 py-3 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent" placeholder="John" data-id="element-444" />
                </div>
                <div data-id="element-445">
                  <label className="block text-sm font-medium text-navy mb-2" data-id="element-446">
                    Last Name
                  </label>
                  <input type="text" className="w-full px-4 py-3 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent" placeholder="Doe" data-id="element-447" />
                </div>
              </div>
              <div data-id="element-448">
                <label className="block text-sm font-medium text-navy mb-2" data-id="element-449">
                  Email Address
                </label>
                <input type="email" className="w-full px-4 py-3 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent" placeholder="john@example.com" data-id="element-450" />
              </div>
              <div data-id="element-451">
                <label className="block text-sm font-medium text-navy mb-2" data-id="element-452">
                  Message
                </label>
                <textarea rows={4} className="w-full px-4 py-3 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent" placeholder="How can we help you grow?" data-id="element-453"></textarea>
              </div>
              <button className="w-full py-4 bg-navy text-white font-bold rounded-md hover:bg-navy-deep transition-colors" data-id="element-454">
                Send Message
              </button>
            </form>
          </div>
        </motion.div>
      </div>
    </main>;
}